export default "__VITE_ASSET__CZv7Lqew__"